import type { LoadingState } from './types'
import type { ApiClientV1 } from '../api'

export class PackageLoader {
  // See ./components.ts for a comment about the use of LoadingState
  private cache: { [key: string]: LoadingState<void> } = {}
  // TODO: To avoid circular dependencies for now any packages have to be manually added
  // by the main bundle package (using addPackage) - later this will be replaced by API
  // calls and script loading
  private packages: { [packageName: string]: () => Promise<unknown> } = {}

  addPackage = (packageName: string, importFn: () => Promise<unknown>) => {
    this.packages[packageName] = importFn
  }

  load(apiClient: ApiClientV1, packageName: string) {
    if (!(packageName in this.cache)) {
      this.cache[packageName] = {
        state: 'loading',
        promise: this.asyncLoad(apiClient, packageName),
      }
    }
    return this.cache[packageName]
  }

  isPackageIsInRegistry = async (packageName: string) => {
    return packageName in this.packages
  }

  private async asyncLoad(_: ApiClientV1, packageName: string) {
    const packageIsInRegistry = await this.isPackageIsInRegistry(packageName)

    try {
      if (packageIsInRegistry) {
        // TODO: will eventually need to use apiClient to work out where to get the package
        await this.packages[packageName]()
        this.cache[packageName] = { state: 'loaded', value: undefined }
      } else {
        // Automatically add package if it does not already exist
        this.addPackage(packageName, () => Promise.resolve())
      }
      this.cache[packageName] = { state: 'loaded', value: undefined }
    } catch (error) {
      console.error(error)
      this.cache[packageName] = { state: 'error', error: error as Error }
    }
    return this.cache[packageName]
  }
}

export const packageLoader = new PackageLoader()
